var YOGO_APP_SERVER = 'weareplugin.yogo.dk';

!function () {
  var baseUrl = 'https://' + YOGO_APP_SERVER + '/widgets/';
  var request = new XMLHttpRequest();

  request.onloadend = function () {
    if (request.status >= 200 && request.status < 300) {
      var files = JSON.parse(request.responseText);
      var cssFiles = files.css;
      var jsFiles = files.js;

      for (var i = 0; i < cssFiles.length; i++) {
        var stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.setAttribute('type', 'text/css');
        stylesheet.href = baseUrl + cssFiles[i];
        document.head.appendChild(stylesheet);
      }

      for (var j = 0; j < jsFiles.length; j++) {
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        // Dynamically-created scripts are async by default. Preserve the file-list
        // order so slower mobile connections cannot reorder dependent bundles.
        script.async = false;
        script.src = baseUrl + jsFiles[j];
        document.head.appendChild(script);
      }
    } else {
      console.error('YOGO: Failed to get widget file list from app server.');
    }
  };

  request.open(
    'GET',
    baseUrl + 'filelist.json?cachebuster=' + Date.now()
  );

  request.send();
}();